import TripRequestDetailsSidebar from './trip-request-details-sidebar-container';

export default TripRequestDetailsSidebar;
